
import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Maincomponent from './Components';
import ClassunderStudent from './Components/classunderStudent';
import PrintStudentCardsMultiple from './Components/printStudentCardsMultiple';
import StudentClassSelect from './Components/studentClassSelect';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Course() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: '#47a54b' }}>
        <Tabs className='classTabs' value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Class Creation   صنف جوړول" {...a11yProps(0)} />
          <Tab label="Class  صنف " {...a11yProps(1)} />
          <Tab label="Students Cards Print  متعلم کارډ جوړول" {...a11yProps(2)} />
          <Tab label="Students Class Selection متعلم ته صنف انتخاب" {...a11yProps(3)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Maincomponent />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        {/* Item Two */}
        <ClassunderStudent />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}> 
        <PrintStudentCardsMultiple /> 
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <StudentClassSelect />  
      </CustomTabPanel>
    </Box>
  );
}